import { atom } from "recoil"

export const AtomUsername = atom({
    key:'ATOMUSERNAME',
    default:''
})
  